// Angular import
import { Component, ElementRef, Input, NgZone, ViewChild } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';

// project import
import { AbleProConfig } from 'src/app/app-config';
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { RequestService } from 'src/app/services/http-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss']
})
export class VerticalMenuComponent {
  // public props
  @Input() menus: NavigationItem[];

  @ViewChild('navbarContent', { static: false }) navbarContent!: ElementRef;
  @ViewChild('navbarWrapper', { static: false }) navbarWrapper!: ElementRef;

  user = {
    name: '',
    surname: ''
  }

  objects: any = [];
  objectId = localStorage.getItem('objectId');

  // Constructor
  constructor(
    private zone: NgZone,
    private location: Location,
    private locationStrategy: LocationStrategy,
    public request: RequestService,
    public router: Router
  ) {

    let user = JSON.parse(localStorage.getItem('hotel_user'));
    this.request.get('administrators/' + user._id).then(res => {
      this.user = res;
      this.getObjects();
    })
  }

  getObjects() {

    this.request.get('objects').then(async objects => {
      this.objects = objects;

      if(!localStorage.getItem('objectId') && this.objects.length > 0){
        localStorage.setItem('objectId', this.objects[0]._id);
        this.objectId = this.objects[0]._id;
      }

    });
  }

  update(){
    localStorage.setItem('objectId', this.objectId);
    window.location.reload();
  }

  logout() {
    localStorage.clear();
    window.location.reload();
  }

  // public method
  fireOutClick() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('coded-hasmenu')) {
        if (AbleProConfig.layout === 'vertical') {
          parent.classList.add('coded-trigger');
        }
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('coded-hasmenu')) {
        if (AbleProConfig.layout === 'vertical') {
          up_parent.classList.add('coded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('coded-hasmenu')) {
        if (AbleProConfig.layout === 'vertical') {
          last_parent.classList.add('coded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }
}
